import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      maxWidth: '380px',
      margin: 'auto',
    },
    icon: {
      color: theme.palette.greyBlue[600],
      '& svg': {
        fontSize: theme.spacing(6),
      },
    },
    title: {
      ...theme.typography.h5,
      color: theme.palette.greyBlue[700],
    },
    body: {
      ...theme.typography.body1,
      textAlign: 'center',
      color: theme.palette.greyBlue[700],
    },
  };
});

const StatusMessage = ({ className, children, title, icon, ...props }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <span className={classes.icon}>{icon}</span>
      <span className={classes.title}>{title}</span>
      <span className={classes.body}>{children}</span>
    </div>
  );
};

StatusMessage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  icon: PropTypes.element,
};

export default StatusMessage;
